import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/functions";
import "firebase/compat/firestore";
import "firebase/compat/storage";
//import { FIREBASE_PROJECT } from "../../app_constant";
import { getFunctions, httpsCallable } from 'firebase/functions';
import { createLogger } from "../utils/logger";

const logger = createLogger(true);
// Debug logs
logger.logAlways("Environment:", process.env.REACT_APP_ENV);



const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};


const firebaseapp = firebase.initializeApp(firebaseConfig);
const app = firebase.app;
const auth = firebase.auth;
const firestore = firebase.firestore;
const storage = firebase.storage;
// const functions = firebase.functions;
const functions = getFunctions(firebaseapp);
export { auth, firestore, storage, functions, app, httpsCallable };
